// Advisories page (agromet crop advisory, history, KCC). Hindi inferred, needs translator.
export const en = {
  "ADVISORIES_PAGE.BREADCRUMB": "Advisories",
  "ADVISORIES_PAGE.TITLE": "Weather",
  "AGROMET_TABS.ARIA_LABEL": "Advisory category",
  "AGROMET_TABS.CROPS": "Crops",
  "AGROMET_TABS.HORTICULTURE": "Horticulture",
  "AGROMET_TABS.LIVESTOCK": "Livestock",
  "AGROMET_OVERVIEW.CROPS": "Crop Advisory Overview",
  "AGROMET_OVERVIEW.HORTICULTURE": "Horticulture Advisory Overview",
  "AGROMET_OVERVIEW.LIVESTOCK": "Livestock Advisory Overview",
  "AGROMET_CARD.VALID_TILL": "Valid till: {{date}}",
  "AGROMET_CARD.KNOW_MORE": "Know more",
  "AGROMET_CARD.KNOW_MORE_ARIA": "Know more about {{crop}} advisory",
  "AGROMET_DETAIL.TITLE": "{{crop}} Advisory",
  "AGROMET_DETAIL.META_ARIA": "Advisory details",
  "AGROMET_DETAIL.META_DATE": "Date",
  "AGROMET_DETAIL.META_PERIOD": "Period",
  "AGROMET_DETAIL.META_DISTRICT": "District",
  "AGROMET_DETAIL.SUMMARY_TITLE": "Summary",
  "AGROMET_DETAIL.LISTEN": "Listen",
  "AGROMET_DETAIL.PAUSE": "Pause",
  "AGROMET_DETAIL.SECTION_CROPS": "Crop Advisory Details",
  "AGROMET_DETAIL.SECTION_HORTICULTURE": "Horticulture Advisory Details",
  "AGROMET_DETAIL.SECTION_LIVESTOCK": "Livestock Advisory Details",
  "AGROMET_DETAIL.WEATHER_SUMMARY": "Weather Summary",
  "AGROMET_DETAIL.ITEM_ADVISORY": "{{crop}} Advisory",
  "AGROMET_DETAIL.SME_ADVISORY": "SME Advisory",
  "AGROMET_DETAIL.SOURCE_IMD": "Source : IMD - Indian meteorological department",
  "AGROMET_DETAIL.NOT_FOUND": "This advisory is no longer available.",
  "AGROMET_DETAIL.BACK": "Back to advisories",
  "AGROMET_DETAIL.SHARE": "Share",
  "AGROMET_DETAIL.COPY_LINK": "Copy link",
  "AGROMET_DETAIL.LINK_COPIED": "Copied",
  "AGROMET_STATE.EMPTY": "No advisories in this category for the selected week.",
  "AGROMET_STATE.ERROR": "Unable to load advisories. Please try again.",
  "AGROMET_STATE.RETRY": "Retry",
  "AGROMET_HISTORY.TITLE": "Advisory History",
  "AGROMET_HISTORY.EMPTY": "No past advisories found.",
  "KCC_BANNER.TITLE": "Kisan Call Centre",
  "KCC_BANNER.COPY_NUMBER": "Copy number",
  "KCC_BANNER.NUMBER_COPIED": "Number copied",
};

export const hi = {
  "ADVISORIES_PAGE.BREADCRUMB": "सलाह",
  "ADVISORIES_PAGE.TITLE": "मौसम",
  "AGROMET_TABS.ARIA_LABEL": "सलाह श्रेणी",
  "AGROMET_TABS.CROPS": "फसलें",
  "AGROMET_TABS.HORTICULTURE": "बागवानी",
  "AGROMET_TABS.LIVESTOCK": "पशुधन",
  "AGROMET_OVERVIEW.CROPS": "फसल सलाह अवलोकन",
  "AGROMET_OVERVIEW.HORTICULTURE": "बागवानी सलाह अवलोकन",
  "AGROMET_OVERVIEW.LIVESTOCK": "पशुधन सलाह अवलोकन",
  "AGROMET_CARD.VALID_TILL": "मान्य: {{date}} तक",
  "AGROMET_CARD.KNOW_MORE": "और जानें",
  "AGROMET_CARD.KNOW_MORE_ARIA": "{{crop}} सलाह के बारे में और जानें",
  "AGROMET_DETAIL.TITLE": "{{crop}} सलाह",
  "AGROMET_DETAIL.META_ARIA": "सलाह विवरण",
  "AGROMET_DETAIL.META_DATE": "दिनांक",
  "AGROMET_DETAIL.META_PERIOD": "अवधि",
  "AGROMET_DETAIL.META_DISTRICT": "ज़िला",
  "AGROMET_DETAIL.SUMMARY_TITLE": "सारांश",
  "AGROMET_DETAIL.LISTEN": "सुनें",
  "AGROMET_DETAIL.PAUSE": "रोकें",
  "AGROMET_DETAIL.SECTION_CROPS": "फसल सलाह विवरण",
  "AGROMET_DETAIL.SECTION_HORTICULTURE": "बागवानी सलाह विवरण",
  "AGROMET_DETAIL.SECTION_LIVESTOCK": "पशुधन सलाह विवरण",
  "AGROMET_DETAIL.WEATHER_SUMMARY": "मौसम सारांश",
  "AGROMET_DETAIL.ITEM_ADVISORY": "{{crop}} सलाह",
  "AGROMET_DETAIL.SME_ADVISORY": "विशेषज्ञ सलाह",
  "AGROMET_DETAIL.SOURCE_IMD": "स्रोत : आईएमडी - भारत मौसम विज्ञान विभाग",
  "AGROMET_DETAIL.NOT_FOUND": "यह सलाह अब उपलब्ध नहीं है।",
  "AGROMET_DETAIL.BACK": "सलाह पर वापस जाएँ",
  "AGROMET_DETAIL.SHARE": "साझा करें",
  "AGROMET_DETAIL.COPY_LINK": "लिंक कॉपी करें",
  "AGROMET_DETAIL.LINK_COPIED": "कॉपी हो गया",
  "AGROMET_STATE.EMPTY": "चयनित सप्ताह में इस श्रेणी के लिए कोई सलाह नहीं है।",
  "AGROMET_STATE.ERROR": "सलाह लोड नहीं हो सकी। कृपया पुनः प्रयास करें।",
  "AGROMET_STATE.RETRY": "पुनः प्रयास करें",
  "AGROMET_HISTORY.TITLE": "सलाह इतिहास",
  "AGROMET_HISTORY.EMPTY": "कोई पिछली सलाह नहीं मिली।",
  "KCC_BANNER.TITLE": "किसान कॉल सेंटर",
  "KCC_BANNER.COPY_NUMBER": "नंबर कॉपी करें",
  "KCC_BANNER.NUMBER_COPIED": "नंबर कॉपी हो गया",
};
